import { fontName } from "@provider/dripsy";
import { useDripsyTheme, useSx } from "dripsy";
import * as React from "react";
import type { TextStyle } from "react-native";
import type { TabBarProps } from "react-native-tab-view";
import { TabBar } from "react-native-tab-view";

export default function CustomTabBar(props: TabBarProps<any>) {
  const {
    theme: { colors, customFonts },
  } = useDripsyTheme();
  const font = customFonts[fontName];

  const sx = useSx();
  const labelStyle: TextStyle = React.useMemo(
    () => ({
      fontSize: 14,
      textTransform: "none",
      color: colors.$text,
      fontFamily: font.bold,
    }),
    [colors, font]
  );
  const styles = React.useMemo(() => {
    return {
      tabBarInactiveTintColor: "black",
      tabBarIndicatorStyle: { backgroundColor: "#000000" },
      style: sx({
        backgroundColor: "$secondaryBackground",
      }),
    };
  }, [colors, font]);

  const options = React.useMemo(() => {
    const result: Record<string, { labelStyle: TextStyle }> = {};
    for (const route of props.navigationState.routes) {
      result[route.key] = { labelStyle };
    }
    return result;
  }, [props.navigationState.routes, labelStyle]);

  return (
    <TabBar
      {...props}
      indicatorStyle={styles.tabBarIndicatorStyle}
      options={options}
      inactiveColor={styles.tabBarInactiveTintColor}
      style={styles.style}
    />
  );
}
